import { Button } from "antd";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import DeleteAccountModal from "../../../../modals/DeleteAccountModal";
import LogoutModal from "../../../../modals/LogoutModal";
import {
  setMenuTitle,
  setShowMenu,
  setShowSubMenu,
} from "../../../../redux/slices/common_slice";
import { routePaths } from "../../../../routing/routePaths";

const LeftSideLayout = () => {
  const [deleteAccount, setDeleteAccount] = useState(false);
  const [logoutAccount, setLogoutAccount] = useState(false);
  const stepperStatus = useSelector((state) => state.common?.stepperStatus);
  const userData = useSelector((state) => state?.user?.userData);
  const userFormData = useSelector((state) => state.form.userData);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const showDeleteAccountModal = (visible) => {
    setDeleteAccount(visible);
  };
  const showLogoutAccountModal = (visible) => {
    setLogoutAccount(visible);
  };
  const redirectToWebPage = () => {
    window.open("https://www.creditcanada.com/contact-us", " _blank");
  };

  const handleShowHideMenu = (title) => {
    dispatch(setShowMenu(false));
    if (title != t("settings.editForm")) {
      dispatch(setShowSubMenu(false));
    }
    dispatch(setMenuTitle(title));
  };

  const handleShowHideSubMenu = () => {
    dispatch(setShowSubMenu(false));
    dispatch(setShowMenu(false));
  };
  return (
    <>
      <div className="row mx-0">
        <div className="col-12 mx-0">
          {window.location.href?.includes("edit-form") ? (
            <ul className="list-inline mb-0 common-btn-layout-settings">
              <li>
                <Button
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate(`/settings/edit-form/${routePaths.editProfile}`);
                    dispatch(setMenuTitle(t("commonStepper.section1")));
                    handleShowHideSubMenu();
                  }}
                  className={
                    window.location.href?.includes("about") &&
                    window.innerWidth > 768
                      ? "active"
                      : ""
                  }
                >
                  <div className="icon-with-title">
                    <div className="icon-container">
                      <img
                        src="/assets/images/icons/privacy-policy.svg"
                        alt=""
                        className="img-fluid"
                      />
                    </div>
                    <h6 className="mb-0">{t("commonStepper.section1")}</h6>
                  </div>
                  <div className="arrow-right-icon">
                    <img
                      src="/assets/images/icons/arrow-right-black.svg"
                      alt=""
                      className="img-fluid"
                    />
                  </div>
                </Button>
              </li>
              {userFormData?.livingInCanada === "yes" && (
                <>
                  <li>
                    <Button
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate(
                          `/settings/edit-form/${routePaths.editIncome}`
                        );
                        dispatch(setMenuTitle(t("commonStepper.section2")));
                        handleShowHideSubMenu();
                      }}
                      className={
                        window.location.href?.includes("income") &&
                        window.innerWidth > 768
                          ? "active"
                          : ""
                      }
                    >
                      <div className="icon-with-title">
                        <div className="icon-container">
                          <img
                            src="/assets/images/icons/privacy-policy.svg"
                            alt=""
                            className="img-fluid"
                          />
                        </div>
                        <h6 className="mb-0">{t("commonStepper.section2")}</h6>
                      </div>
                      <div className="arrow-right-icon">
                        <img
                          src="/assets/images/icons/arrow-right-black.svg"
                          alt=""
                          className="img-fluid"
                        />
                      </div>
                    </Button>
                  </li>
                  <li>
                    <Button
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate(
                          `/settings/edit-form/${routePaths.editExpenses}`
                        );
                        dispatch(setMenuTitle(t("commonStepper.section3")));
                        handleShowHideSubMenu();
                      }}
                      className={
                        window.location.href?.includes("expenses") &&
                        window.innerWidth > 768
                          ? "active"
                          : ""
                      }
                    >
                      <div className="icon-with-title">
                        <div className="icon-container">
                          <img
                            src="/assets/images/icons/partner-support-white-icon.svg"
                            alt=""
                            className="img-fluid"
                          />
                        </div>
                        <h6 className="mb-0">{t("commonStepper.section3")}</h6>
                      </div>
                      <div className="arrow-right-icon">
                        <img
                          src="/assets/images/icons/arrow-right-black.svg"
                          alt=""
                          className="img-fluid"
                        />
                      </div>
                    </Button>
                  </li>
                </>
              )}
            </ul>
          ) : (
            <>
              <h6 className="settings-title-tag">{t("settings.support")}</h6>
              <ul className="list-inline mb-0 common-btn-layout-settings">
                <li>
                  <Button
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate(routePaths.resources);
                      handleShowHideMenu(t("settings.resources"));
                    }}
                  >
                    <div className="icon-with-title">
                      <div className="icon-container">
                        <img
                          src="/assets/images/icons/resources-white-icon.svg"
                          alt=""
                          className="img-fluid"
                        />
                      </div>
                      <h6 className="mb-0">{t("settings.resources")}</h6>
                    </div>
                    <div className="arrow-right-icon">
                      <img
                        src="/assets/images/icons/arrow-right-black.svg"
                        alt=""
                        className="img-fluid"
                      />
                    </div>
                  </Button>
                </li>
                <li>
                  <Button
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate(routePaths.helpAndSupport);
                      handleShowHideMenu(t("settings.helpSupport"));
                    }}
                  >
                    <div className="icon-with-title">
                      <div className="icon-container">
                        <img
                          src="/assets/images/icons/help-and-support-white-icon.svg"
                          alt=""
                          className="img-fluid"
                        />
                      </div>
                      <h6 className="mb-0">{t("settings.helpSupport")}</h6>
                    </div>
                    <div className="arrow-right-icon">
                      <img
                        src="/assets/images/icons/arrow-right-black.svg"
                        alt=""
                        className="img-fluid"
                      />
                    </div>
                  </Button>
                </li>
                <li>
                  <Button
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate(routePaths.faqs);
                      handleShowHideMenu(t("settings.faqs"));
                    }}
                  >
                    <div className="icon-with-title">
                      <div className="icon-container">
                        <img
                          src="/assets/images/icons/faqs-white-icon.svg"
                          alt=""
                          className="img-fluid"
                        />
                      </div>
                      <h6 className="mb-0">{t("settings.faqs")}</h6>
                    </div>
                    <div className="arrow-right-icon">
                      <img
                        src="/assets/images/icons/arrow-right-black.svg"
                        alt=""
                        className="img-fluid"
                      />
                    </div>
                  </Button>
                </li>
                <li>
                  <Button onClick={redirectToWebPage}>
                    <div className="icon-with-title">
                      <div className="icon-container">
                        <img
                          src="/assets/images/icons/faqs-white-icon.svg"
                          alt=""
                          className="img-fluid"
                        />
                      </div>
                      <h6 className="mb-0">{t("settings.contact")}</h6>
                    </div>
                  </Button>
                </li>
              </ul>
              {stepperStatus?.isExpenseCompleted && (
                <>
                  <h6 className="settings-title-tag">
                    {t("settings.appSettings")}
                  </h6>
                  <ul className="list-inline mb-0 common-btn-layout-settings">
                    <li>
                      <Button
                        onClick={(e) => {
                          e.stopPropagation();
                          navigate(routePaths.notifications);
                          handleShowHideMenu(t("settings.notifications"));
                        }}
                      >
                        <div className="icon-with-title">
                          <div className="icon-container">
                            <img
                              src="/assets/images/icons/notifications-icon-white.svg"
                              alt=""
                              className="img-fluid"
                            />
                          </div>
                          <h6 className="mb-0">
                            {t("settings.notifications")}
                          </h6>
                        </div>
                        <div className="arrow-right-icon">
                          <img
                            src="/assets/images/icons/arrow-right-black.svg"
                            alt=""
                            className="img-fluid"
                          />
                        </div>
                      </Button>
                    </li>
                    <li>
                      <Link
                        to={
                          window.innerWidth < 768
                            ? "/settings/edit-form"
                            : `/settings/edit-form/${routePaths.editProfile}`
                        }
                      >
                        <Button
                          onClick={(e) => {
                            e.stopPropagation();
                            handleShowHideMenu(t("settings.editForm"));
                          }}
                        >
                          <div className="icon-with-title">
                            <div className="icon-container">
                              <img
                                src="/assets/images/icons/edit-form-icon-white.svg"
                                alt=""
                                className="img-fluid"
                              />
                            </div>
                            <h6 className="mb-0">{t("settings.editForm")}</h6>
                          </div>
                          <div className="arrow-right-icon">
                            <img
                              src="/assets/images/icons/arrow-right-black.svg"
                              alt=""
                              className="img-fluid"
                            />
                          </div>
                        </Button>
                      </Link>
                    </li>
                    <li>
                      <Button
                        onClick={(e) => {
                          e.stopPropagation();
                          navigate(routePaths.myBudgets);
                          handleShowHideMenu(t("settings.myBudgets"));
                        }}
                      >
                        <div className="icon-with-title">
                          <div className="icon-container">
                            <img
                              src="/assets/images/icons/my-budgets-icon-white.svg"
                              alt=""
                              className="img-fluid"
                            />
                          </div>
                          <h6 className="mb-0">{t("settings.myBudgets")}</h6>
                        </div>
                        <div className="arrow-right-icon">
                          <img
                            src="/assets/images/icons/arrow-right-black.svg"
                            alt=""
                            className="img-fluid"
                          />
                        </div>
                      </Button>
                    </li>
                  </ul>
                </>
              )}
              <h6 className="settings-title-tag">
                {t("settings.accountSettings")}
              </h6>
              <ul className="list-inline mb-0 common-btn-layout-settings">
                {userData?.loginType === "email" && (
                  <li>
                    <Button
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate(routePaths.changePassword);
                        handleShowHideMenu(t("settings.changePass"));
                      }}
                    >
                      <div className="icon-with-title">
                        <div className="icon-container">
                          <img
                            src="/assets/images/icons/lock-icon-white.svg"
                            alt=""
                            className="img-fluid"
                          />
                        </div>
                        <h6 className="mb-0">{t("settings.changePass")}</h6>
                      </div>
                      <div className="arrow-right-icon">
                        <img
                          src="/assets/images/icons/arrow-right-black.svg"
                          alt=""
                          className="img-fluid"
                        />
                      </div>
                    </Button>
                  </li>
                )}
                <li>
                  <Button onClick={() => showDeleteAccountModal(true)}>
                    <div className="icon-with-title">
                      <div className="icon-container">
                        <img
                          src="/assets/images/icons/delete-account-white-icon.svg"
                          alt=""
                          className="img-fluid"
                        />
                      </div>
                      <h6 className="mb-0">{t("settings.deleteAc")}</h6>
                    </div>
                  </Button>
                </li>
                <li>
                  <Button onClick={() => showLogoutAccountModal(true)}>
                    <div className="icon-with-title">
                      <div className="icon-container">
                        <img
                          src="/assets/images/icons/notifications-icon-white.svg"
                          alt=""
                          className="img-fluid"
                        />
                      </div>
                      <h6 className="mb-0">{t("settings.logout")}</h6>
                    </div>
                  </Button>
                </li>
              </ul>
              <h6 className="settings-title-tag">{t("settings.details")}</h6>
              <ul className="list-inline mb-0 common-btn-layout-settings">
                <li>
                  <Button
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate(routePaths.settingsPrivacyPolicy);
                      handleShowHideMenu(t("settings.privacyPolicy"));
                    }}
                  >
                    <div className="icon-with-title">
                      <div className="icon-container">
                        <img
                          src="/assets/images/icons/privacy-policy.svg"
                          alt=""
                          className="img-fluid"
                        />
                      </div>
                      <h6 className="mb-0">{t("settings.privacyPolicy")}</h6>
                    </div>
                    <div className="arrow-right-icon">
                      <img
                        src="/assets/images/icons/arrow-right-black.svg"
                        alt=""
                        className="img-fluid"
                      />
                    </div>
                  </Button>
                </li>
                <li>
                  <Button
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate(routePaths.settingsTemsNConditions);
                      handleShowHideMenu(t("settings.tnc"));
                    }}
                  >
                    <div className="icon-with-title">
                      <div className="icon-container">
                        <img
                          src="/assets/images/icons/privacy-policy.svg"
                          alt=""
                          className="img-fluid"
                        />
                      </div>
                      <h6 className="mb-0">{t("settings.tnc")}</h6>
                    </div>
                    <div className="arrow-right-icon">
                      <img
                        src="/assets/images/icons/arrow-right-black.svg"
                        alt=""
                        className="img-fluid"
                      />
                    </div>
                  </Button>
                </li>
                {false && (
                <li>
                  <Button
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate(routePaths.partnersSponsors);
                      handleShowHideMenu(t("settings.partners"));
                    }}
                  >
                    <div className="icon-with-title">
                      <div className="icon-container">
                        <img
                          src="/assets/images/icons/partner-support-white-icon.svg"
                          alt=""
                          className="img-fluid"
                        />
                      </div>
                      <h6 className="mb-0">{t("settings.partners")}</h6>
                    </div>
                    <div className="arrow-right-icon">
                      <img
                        src="/assets/images/icons/arrow-right-black.svg"
                        alt=""
                        className="img-fluid"
                      />
                    </div>
                  </Button>
                </li>
                )}
              </ul>
            </>
          )}
        </div>
      </div>
      <LogoutModal
        open={logoutAccount}
        onClose={() => showLogoutAccountModal(false)}
      />
      <DeleteAccountModal
        open={deleteAccount}
        onClose={() => showDeleteAccountModal(false)}
      />
    </>
  );
};

export default LeftSideLayout;
